import React from 'react';
import { withRouter } from 'react-router';
import {
  Route,
  Switch,
  Redirect
} from 'react-router-dom';

import Login from '../../login/view';
import ForgetPassword from '../../forget-password/view';
import ResetPassword from '../../reset-password/view';

const createRoutePath = (path, component) => (
  {
    path,
    component
  }
)

const routes = [
  createRoutePath("/login", Login),
  createRoutePath("/forget-password", ForgetPassword),
  createRoutePath("/reset-password/:credentials", ResetPassword)
];

const Root = () => (
  <Switch>
    {routes.map(r => <Route key={r.path} exact path={r.path} component={r.component} />)}
    <Route render={() => <Redirect to={{ pathname: "/login"}} />}/>
  </Switch>
)

export default withRouter(Root);